import store from "@/store";
import {useRouter} from "vue-router";
import {aicoreBackendPetition} from "@/utils/aicore_petition";

export class Endpoints {
    /*
     * This class basically simulates being an enumerate object.
     * This way we can select a connection avoiding typos.
     */
    static AICORE = new Endpoints('AICORE');
    static EXTERNOS = new Endpoints('EXTERNOS');
    static ANALYTICS = new Endpoints('ANALYTICS');
    static LOOKER = new Endpoints('LOOKER');

    constructor(name) {
        this.name = name;
    }
    toString() {
        return `Endpoints.${this.name}`;
    }
}


export async function hasPermission(route) {
    const router = useRouter();
    let has_permission = true;

    if (isLogged()) {
        switch (route.name) {
            case 'gestor-grupos-roles':
            case 'gestor-dashboard-roles':
            case 'gestor-roles':
            case 'admin':
            case 'asignacion-fuerza-ventas-a-matriculas':
            case 'incongruencias':
                has_permission = belongGroup(getAdminGroups());
                break;
            case 'creacion-video-producto':
                has_permission = belongGroup(getAudiovisualGroups());
                break;
            case 'importacion-nominas':
                has_permission = belongGroup(getRRHHGroups());
                break;
            case 'objetivos-fuerza-ventas':
                has_permission = belongGroup(getObjectivesEditorsGroups());
                break;
            case 'generacion-guiones-para-cursos':
                has_permission = belongGroup(getScriptCourseGeneratorGroups());
                break;
            case 'gestion-peticion-acceso':
            case 'eliminar-dashboard-usuario':
                has_permission = belongGroup(getDashboardAccessGroups());
                break;
        }

        if (!route.fullPath.includes('acceso-denegado')) {
            await saveLogVisit(route.fullPath, has_permission)
        }
        return (has_permission ? true : router.push({name: 'not-allowed'}))
    }
    return router.push({name: 'login'})

}

// The BFF holds the service-account credentials and calls /login-ldap itself.
export async function authenticate(username, password) {
    return $.ajax({
        type: "POST",
        url: "/bff/login",
        data: {username, password},
        headers: {'X-Requested-With': 'XMLHttpRequest'},
    });
}

export async function getAicoreToken(ext = false) {
    let env_password = process.env.VUE_APP_AICORE_AUTH_PASSWORD;
    let env_user = process.env.VUE_APP_AICORE_AUTH_USER;
    let env_token = process.env.VUE_APP_AICORE_URL_TOKEN;

    if (ext) {
        env_password = process.env.VUE_APP_AICORE_AUTH_EXT_PASSWORD;
        env_user = process.env.VUE_APP_AICORE_AUTH_EXT_USER;
        //env_token = process.env.VUE_APP_AICORE_URL_TOKEN_LOOKER
        env_token = process.env.VUE_APP_AICORE_URL_TOKEN_EXT

    }


    let password = Math.random().toString(36).substring(2, 6) + env_password + Math.random().toString(36).substring(2, 6)

    return $.ajax({
        type: "POST",
        url: env_token,
        data: {
            username: env_user,
            password: btoa(password)
        }
    });
}

/* Request token from diferent endpoints.
 * @param {Endpoints} endpoint Value name of the available endpoints such as "aicore"
 */
export async function fetchToken(endpoint){
    let env_password = process.env.VUE_APP_AICORE_AUTH_PASSWORD;
    let env_user = process.env.VUE_APP_AICORE_AUTH_USER;
    let env_token = process.env.VUE_APP_AICORE_URL_TOKEN;

    switch(endpoint){
        case Endpoints.AICORE.name:
            break;
        case Endpoints.EXTERNOS.name:
            env_password = process.env.VUE_APP_AICORE_AUTH_EXT_PASSWORD;
            env_user = process.env.VUE_APP_AICORE_AUTH_EXT_USER;
            env_token = process.env.VUE_APP_AICORE_URL_TOKEN_EXT;
            break;
        case Endpoints.ANALYTICS.name:
            env_password = process.env.VUE_APP_AISEO_ANALYTICS_AUTH_EXT_PASSWORD;
            env_user = process.env.VUE_APP_AISEO_ANALYTICS_AUTH_EXT_USER;
            env_token = process.env.VUE_APP_AISEO_ANALYTICS_URL_TOKEN_EXT;
            break;
        case Endpoints.LOOKER.name:
            env_password = process.env.VUE_APP_AICORE_AUTH_EXT_PASSWORD;
            env_user = process.env.VUE_APP_AICORE_AUTH_EXT_USER;
            env_token = process.env.VUE_APP_AICORE_URL_TOKEN_LOOKER;
            break;
        default:
            throw new Error('Invalid endpoint selected. There is no endpoint: ' + endpoint);
    }

    let password = Math.random().toString(36).substring(2, 6) + env_password + Math.random().toString(36).substring(2, 6)
    return $.ajax({
        type: "POST",
        url: env_token,
        data: {
            username: env_user,
            password: env_password
        }
    });
}


export function isLogged() {
    return store.getters.getUsername !== ""
}

export async function logout() {
    localStorage.clear()
    store.commit('setUsername', "")
    store.commit('setAicoreToken', "")
    // Without this the groups survive in Vuex state until the page reloads:
    // localStorage.clear() only wipes the persisted copy, and getUserGroup
    // returns state.group whenever it is not empty.
    store.commit('setGroup', "")
    // Best effort: the BFF clears the HttpOnly session cookie.
    try {
        fetch('/bff/logout', {method: 'POST', headers: {'X-Requested-With': 'XMLHttpRequest'}, credentials: 'same-origin'}).catch(() => {})
    } catch { /* ignore */ }
}

const SESSION_MAX_HOURS = 4

// Logs out an expired or denied session. Returns whether the session is still valid.
export function enforceSession() {
    const saved = localStorage.getItem('saved')
    if (saved && (new Date().getTime() - saved > SESSION_MAX_HOURS * 60 * 60 * 1000)) {
        logout()
        return false
    }
    if (!store.getters.getUsername || !store.getters.getToken) {
        return false
    }
    if (isDeniedPlatformAccess()) {
        logout()
        return false
    }
    return true
}

// Router guard: App.vue swaps to the login view by itself once the session is gone.
export function sessionGuard() {
    enforceSession()
}

export async function saveLogVisit(to, visited) {
    if (process.env.NODE_ENV !== 'development') {
        var data = {
            url: to,
            username: store.getters.getUsername,
            visualizado: visited ? 1 : 0,
            application: 'aicore'
        };
        await aicoreBackendPetition('GET', '/Logs/save_log_visualizacion_app', data, {ext: true});
    }
}


export function belongGroup(allowed_groups) {
    let user_groups = store.getters.getUserGroup
    let array_user_groups = user_groups.split(',')

    let belong = false;
    array_user_groups.forEach(group => {
        if (allowed_groups.includes(parseInt(group))) {
            belong = true;
        }
    })
    return belong;
}

/*
 * The numbers below are the backend's own group ids (`id_grupo_ldap`), not the
 * gidNumber stored in Active Directory - the two numbering schemes differ. The
 * authoritative id-to-name map is `GET /EmbedLooker/get_all_grupos_ldap`, shown
 * in the admin screen at /admin/gestor-grupos-roles. Check a comment against
 * that endpoint before trusting it; several were left stale by group renames.
 */
export function getRRHHGroups() {
    let specific = [
        4743 /*DPTO.HR*/,
        4744 /*DPTO.HR.ADMIN*/,
        3639 /*CM.CORPORATE LEARNING COMMISSION.ADMIN*/
    ]
    return [...getAdminGroups(), ...specific]
}

export function getAudiovisualGroups() {
    let specific = [
        4540 /*GR.INNOVA STUDIOS*/,
        4541 /*GR.INNOVA STUDIOS.ADMIN*/,
    ]
    return [...getAdminGroups(), ...specific]
}

export function getObjectivesEditorsGroups() {
    let specific = [
        5738 /*CM.SALES COMMISSION.ADMIN*/,
        6009/*CM.STRATEGIC PARTNERSHIP.ADMIN - not in the directory, verify*/,
        6862/*CM.LATAM GROWTH.ADMIN - not in the directory, verify*/,
        3639 /*CM.CORPORATE LEARNING COMMISSION.ADMIN*/
    ]
    return [...getAdminGroups(), ...specific]
}

export function getScriptCourseGeneratorGroups() {
    let specific = [
        4540 /*GR.INNOVA STUDIOS*/,
        4541 /*GR.INNOVA STUDIOS.ADMIN*/,
        6057 /*GR.B2B MARKETING*/,
        6058 /*GR.B2B MARKETING.ADMIN*/,
    ]
    return [...getAdminGroups(), ...specific]
}

export function getTranslatorGroups() {
    let specific = [
        6168 /*DPTO.PRODUCT.ADMIN*/,
        6167 /*DPTO.PRODUCT*/,
        6074 /*AREA.BUSINESS AREA*/,
        3980 /*CM.PUBLISHING COMMISSION*/
    ]
    return [...getAdminGroups(), ...specific]
}

export function getAssignFFVVGroups() {
    let specific = [
        5455 /*GR.ENROLLMENT SUPPORT.ADMIN*/,
        8967 /*	GR.CROSS SELLING.ADMIN*/
    ]
    return [...getAdminGroups(), ...specific]
}

export function getAdminGroups() {
    return [
        5813/* PR.PROYECTO IA CORE - not in the directory, verify*/,
        5814/* PR.PROYECTO IA CORE.ADMIN - not in the directory, verify*/,
        3628/* GR.DEVOPS.ADMIN - not in the directory, verify*/,
        5155/*GR.EXECUTIVE COMMITTEE*/,
        6971/*PR.OPERACIONES-AICORE - not in the directory, verify*/,
        4995/*CM.OPERATIONS COMMISSION*/,
        3556 /*CIA.MORENO HIDALGO*/,
        7594/*GR.EDUSEO.AI - not in the directory, verify*/,
        7612/*GR.DATA*/,
        7613 /* GR.DATA.ADMIN */,
        7614 /* GR.DATA.COLAB */,
        5156 /* GR.EXECUTIVE COMMITTEE.ADMIN */,
    ]
}

export function getDevelopGroups() {
    return [
        5813/*PR.PROYECTO IA CORE - not in the directory, verify*/,
        5814/*PR.PROYECTO IA CORE.ADMIN - not in the directory, verify*/,
        6656/*DPTO.WEBS.ADMIN - not in the directory, verify*/,
        6655/*DPTO.WEBS - not in the directory, verify*/,
        7594/*GR.EDUSEO.AI - not in the directory, verify*/,
        7612/*GR.DATA*/,
        7613 /* GR.DATA.ADMIN */,
        7614 /* GR.DATA.COLAB */,
    ]
}

export function getAcademicDashboardGroups() {
    let specific = [
        4201 /*GR.BRANDING BUSINESS.ADMIN*/,
        4056 /*GR.CALL CENTER EUROCURSOS.ADMIN*/,
        4054 /*GR.CALL CENTER EURO MASTERS.ADMIN*/,
        5455 /*GR.ENROLLMENT SUPPORT.ADMIN*/,
        5741 /*GR.CONTACT CENTER.ADMIN*/,
    ]

    return [...getAdminGroups(), ...specific]
}

export function getDashboardAccessGroups() {
    let specific = [
        7613 /* GR.EDUCORE.AI.ADMIN */,
        5156 /* GR.EXECUTIVE COMMITTEE.ADMIN */
    ]

    return  [...specific]
}

/*
 * id_grupo_ldap of GR.EDUCORE.ACCESS.DENIED and its subgroups, taken from
 * GET /EmbedLooker/get_all_grupos_ldap. The ids here are backend id_grupo_ldap
 * values, not AD gidNumber. Their members lose access to the whole platform.
 * Confirm a new id against the groups a real member receives at login
 * (localStorage 'group'): 1.50.1 shipped 9731, which members do not receive.
 */
export function getDeniedGroups() {
    return [
        9737, // GR.EDUCORE.ACCESS.DENIED
        9738, // GR.EDUCORE.ACCESS.DENIED.ADMIN
        9739, // GR.EDUCORE.ACCESS.DENIED.COLAB
    ]
}

// Deny wins: membership in any other group does not override it.
export function isDeniedPlatformAccess(deniedGroups = getDeniedGroups()) {
    return belongGroup(deniedGroups)
}
